import { a } from "./index828.mjs";
import { i as t } from "./index778.mjs";
import "./index789.mjs";
import { __exports as s } from "./index790.mjs";
var p = a, m = t, n = s, l = function(e, r) {
  if (p(e), m(r) && r.constructor === e)
    return r;
  var i = n.f(e), o = i.resolve;
  return o(r), i.promise;
};
export {
  l as p
};
